import { render, staticRenderFns } from "./SpyderBrandModal.vue?vue&type=template&id=18d1b8b0&scoped=true"
import script from "./SpyderBrandModal.vue?vue&type=script&lang=js"
export * from "./SpyderBrandModal.vue?vue&type=script&lang=js"
import style0 from "./SpyderBrandModal.vue?vue&type=style&index=0&id=18d1b8b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d1b8b0",
  null
  
)

export default component.exports